<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0 no-gutter">
        <back-button :returnUrl = "returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <email-sender-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></email-sender-form>
      <b-row class="justify-content-end no-gutter">
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('details')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('edit')">
          <i class="fa-light fa-pencil"></i>
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="deleteEmailSender">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="editEmailSender">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'add'"
          class="mx-3"
          @click="addEmailSender">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import EmailSenderForm from '@/pages/email/EmailSenderForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "EmailSenderDetails",
  components: {
    'back-button': backButton,
    'email-sender-form': EmailSenderForm,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.email_sender_edit');
        case 'details':
          return this.$t('Webheader.email_sender_details');
        case 'add':
        default:
          return this.$t('Webheader.email_sender_add');
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      email: '',
      returnUrl: '',
      currentEmailSender: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/email/emailSender/-1'

    if(this.id !== '-1' && (this.mode === "details" ||"edit")) {
      this.getEmailSender()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addEmailSender () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        SenderName: this.config.SenderName,
        SenderEmail: this.config.SenderEmail,
        SmtpServer: this.config.SmtpServer,
        SmtpPort: this.config.SmtpPort,
        SmtpUser: this.config.SmtpUser,
        SmtpPassword: this.config.SmtpPassword,
        id: this.id
      }
      this.$engine.firstOn().email.emailSender.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_sender_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/email/emailSender/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_sender_addition_error'))
      })
    },
    deleteEmailSender () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdEmailSender: that.id
              }
              that.$engine.firstOn().email.emailSender.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.email.email_sender_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/email/emailSender/-1'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_sender_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editEmailSender () {
      let that = this
      let params = {
        SenderName: this.config.SenderName,
        SenderEmail: this.config.SenderEmail,
        SmtpServer: this.config.SmtpServer,
        SmtpPort: this.config.SmtpPort,
        SmtpUser: this.config.SmtpUser,
        SmtpPassword: this.config.SmtpPassword,
        IdEmailSender: this.id
      }
      this.$engine.firstOn().email.emailSender.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_sender_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, { url: '/email/emailSender/-1' })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_sender_edition_error'))
      })
    },
    fillFields () {
      this.config = this.currentEmailSender
      this.originalConfig = this.currentEmailSender
      this.activateSpinner = false
    },
    formHasError() {
      if (this.config.SenderName === undefined || this.config.SenderName.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_name_missing'));
        return true;
      }
      if (this.config.SenderEmail === undefined || this.config.SenderEmail.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_email_missing'));
        return true;
      }
      if (this.config.SmtpServer === undefined || this.config.SmtpServer.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_smtp_server_missing'));
        return true;
      }
      if (this.config.SmtpPort === undefined || this.config.SmtpPort.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_smtp_port_missing'));
        return true;
      }
      if (this.config.SmtpUser === undefined || this.config.SmtpUser.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_smtp_user_missing'));
        return true;
      }
      if (this.config.SmtpPassword === undefined || this.config.SmtpPassword.length === 0) {
        this.okMessageBox(this.$t('common.email.email_sender_smtp_password_missing'));
        return true;
      }
      return false;
    },
    getEmailSender () {
      let that = this
      this.$engine.firstOn().email.emailSender.fetch({id: this.id})
      .then(resp => {
        let emailSenderList = {}

        emailSenderList = resp.data.EmailSender
        that.updateEmailSender(emailSenderList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateEmailSender (emailSenderList) {
      const selectedEmail = emailSenderList.find(email => email.IdEmailSender === this.id)
      this.currentEmailSender = selectedEmail
      this.fillFields()
    }
  }
}
</script>
